// Unified breakpoint constants for GoodRecord components
// Following design system: primary breakpoint at 768px

export const BREAKPOINTS = {
    MOBILE: '480px',      // Small phones
    TABLET: '768px',      // Tablets and large phones
    DESKTOP: '1024px',    // Desktop
};

// Primary breakpoint - use for most responsive adjustments
export const MOBILE_MAX_WIDTH = BREAKPOINTS.TABLET;

// Media query helpers
export const MEDIA = {
    MOBILE: `@media screen and (max-width: ${BREAKPOINTS.MOBILE})`,
    TABLET: `@media screen and (max-width: ${BREAKPOINTS.TABLET})`,
    DESKTOP: `@media screen and (min-width: ${BREAKPOINTS.DESKTOP})`,
};
